import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface FeedStatType {
  code: string;
  name: string;
  category: 'player' | 'team';
  unit?: string;
}

interface FeedStatTypesResponse {
  statTypes: FeedStatType[];
}

export type { FeedStatType };

export const getFeedStatTypes = async (
  sportId: string,
  opts?: { forLeader?: boolean; kind?: 'player' | 'team' }
): Promise<FeedStatType[]> => {
  const params: Record<string, string> = { sportId };
  if (opts?.forLeader) params.forLeader = 'true';
  if (opts?.kind) params.kind = opts.kind;
  const response = (await api.get('/feed/stat-types', { params })) as FeedStatTypesResponse;
  return response.statTypes || [];
};

export const useGetFeedStatTypesQuery = (
  sportId: string | undefined,
  opts?: { forLeader?: boolean; kind?: 'player' | 'team' }
) => {
  // Include forLeader + kind in the cache key so the three variants
  // (all / leader-player / leader-team) don't collide in React Query.
  const cacheVariant = opts?.forLeader ? `leader-${opts.kind ?? 'player'}` : 'all';
  return useQuery({
    queryKey: [...queryKeys.feed.statTypes(sportId || ''), cacheVariant],
    queryFn: () => {
      if (!sportId) throw new Error('Sport ID is required');
      return getFeedStatTypes(sportId, opts);
    },
    enabled: !!sportId,
    staleTime: 5 * 60 * 1000, // 5 minutes - stat types don't change often
  });
};
